// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var ContractCancellationController = function ($scope, $routeParams, $location, $http, Contract, ProductInfo,
    ContractCancellationPreview, ContractTimeDetails, PUtill, DatepickerUtils) {

    function stringEndsWith(str, suffix) {
        return str.indexOf(suffix, str.length - suffix.length) !== -1;
    }

    $scope.isCancellation = stringEndsWith($location.path(), "/cancel");
    $scope.saveClicked = false;

    var productInfo = ProductInfo.get(function () {
        $scope.contract = Contract.get({ contractId: $routeParams.contractId }, function () {
            $scope.plan = productInfo.PlanById($scope.contract.PlanId);
            $scope.planGroup = productInfo.PlanGroupById($scope.plan.PlanGroupId);

            var planVariant = productInfo.PlanVariantById($scope.contract.PlanVariantId);
            var periodEnd = $scope.contract.CurrentPhase.Type === 'Trial' ? planVariant.ContractPeriod : planVariant.LaterContractPeriod;
            $scope.contractPeriodEnd = PUtill.addPeriod(periodEnd, $scope.contract.CurrentPhase.StartDate);
        });
    });

    if ($scope.isCancellation) {
        $scope.cancellationPreview = ContractCancellationPreview.get({ contractId: $routeParams.contractId });
    }
    else {
        ContractTimeDetails.get({ contractId: $routeParams.contractId }, function (cont) {
            let billedOrNextBillingDate = cont.BilledUntil || cont.NextBillingDate;
            $scope.endDate = billedOrNextBillingDate ? new Date(billedOrNextBillingDate) : null;
            $scope.phaseTime = $scope.endDate || new Date(cont.StartDate);
        });

        $scope.$watch('endDate', function (newValue, oldValue) {
            if (!PUtill.areDatesEqual(newValue, oldValue))
                $scope.fetchEndPreview();
        }, true);

        $scope.fetchEndPreview = function () {            
            $http({
                method: "POST",
                url: "/api/v1/contracts/" + $routeParams.contractId + "/endPreview",
                params: null,
                data: { EndDate: $scope.endDate },
                headers: {},
                cache: false
            }).then(function (response) {
                $scope.cancellationPreview = response.data;
            });
        };
    }

    $scope.endContract = function () {
        if ($scope.saveClicked)
            return;
        
        let correctedEndDate = $scope.endDate || $scope.isCancellation ? DatepickerUtils.backToBrowserTimezone($scope.cancellationPreview.EndDate) : null;
        $scope.saveClicked = true;
        $http({
            method: "POST", url: "/api/v1/contracts/" + $routeParams.contractId + "/end", params: null,
            data: { EndDate: correctedEndDate }, headers: {}, cache: false
        }).then(function () {
            $location.path("/contracts/" + $routeParams.contractId); 
        });
    };
    
};
ContractCancellationController.$inject = ['$scope', '$routeParams', '$location', '$http', 'Contract', 'ProductInfo',
    'ContractCancellationPreview', 'ContractTimeDetails', 'PUtill', 'DatepickerUtils'];
